module.exports = __webpack_public_path__ + "img/sulfur.ore.2d1e959b.png";